import script from "./Admins.vue?vue&type=script&setup=true&lang=js"
export * from "./Admins.vue?vue&type=script&setup=true&lang=js"

import "./Admins.vue?vue&type=style&index=0&id=818dcc30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-818dcc30"]])

export default __exports__